export default __webpack_public_path__ + "static/experienceImg4-d6c910d0ee8048ed45ca345ec996fc7f.png";